import http from "./httpService";

const apiUrl = "https://api-mobileapp.advanceagro.net";
const url = "http://127.0.0.1:8080/api";
export async function getMemulist() {
  return http.get(apiUrl + "/hrm/menu");
}

export async function getEvenLog(startdate='',enddate='',pageSize = 30,
pageNumber = 1) {
  //console.log(id);
  return http.get("/HRM/getEventLog?startdate=" + startdate+"&enddate="+ enddate+"&pageSize=" +
  pageSize +
  "&pageNumber=" +
  pageNumber);
}
export async function activity(doc) {
  return http.post("/hrm/activity", doc);
}
export async function getEvenLogall(startdate='',enddate='') {
  //console.log(id);
  return http.get("/HRM/getEventLogall?startdate=" + startdate+"&enddate="+ enddate+"&pageSize=");
}
export async function getLogPerHour(startdate='') {
  //console.log(id);
  return http.get("/HRM/getLogPerHour?startdate=" + startdate);
}
export default {
  getMemulist
};
